import { ReactElement } from 'react'
import { Typography, Space } from 'antd'

const { Title, Paragraph } = Typography

const General = (): ReactElement => {
  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <div>
        <Title level={4}>General</Title>
        <Paragraph>
          Configure your VirtualLog application settings here.
        </Paragraph>
      </div>
      <div>
        <Title level={4}>Log Retention</Title>
        <Paragraph>Manage how long logs are stored in the system.</Paragraph>
      </div>
      <div>
        <Title level={4}>Notifications</Title>
        <Paragraph>
          Configure alert rules and notification preferences.
        </Paragraph>
      </div>
    </Space>
  )
}

export default General
